import types from "../actions/actionTypes";
import initialState from "./initialState";

export default function projectsIdsNeedingUpdateReducer(state = initialState.projectsIdsNeedingUpdate, action) {

    const mergeIdIn = (projectsIds, id) => {
        return projectsIds.filter(p => p !== id)
            .concat(id);
    }

    switch (action.type) {
        case types.LOAD_PROJECT_WITH_PHASES_SUCCESS:
            return state.filter(s => s !== action.project.id);
        case types.UPDATED_PROJECTITEMACTIVITY_SUCCESS:
            return mergeIdIn(state, action.projectItemActivity.projectId);          
        case types.UPDATED_PHASE_SUCCESS:
        case types.DELETED_PHASE:
            return mergeIdIn(state, action.phase.projectId);     
        case types.UPDATED_PROJECTITEM_SUCCESS:       
            return mergeIdIn(state, action.projectItem.formData.projectId);   
        case types.DELETED_PROJECTITEM:
            return mergeIdIn(state, action.projectItem.projectId);
        case types.UPDATED_PROJECTITEMNOTE_SUCCESS:
        case types.DELETED_PROJECTITEMNOTE:
        case types.UPDATED_PHASENOTE_SUCCESS:
        case types.DELETED_PHASENOTE:            
            return mergeIdIn(state, action.note.projectId);
        case types.DELETED_INVOICE:      
            return mergeIdIn(state, action.project.projectId);
        case types.UPDATED_PROJECTITEMMILESTONE_SUCCESS:
        case types.DELETED_PROJECTITEMMILESTONE:
            return mergeIdIn(state, action.projectItemMilestone.projectId);
        case types.DELETED_PROJECTITEM_INCOMING:
        case types.UPDATED_PROJECTITEMNOTE_INCOMING:
        case types.DELETED_PROJECTITEMNOTE_INCOMING:
        case types.UPDATED_PHASENOTE_INCOMING:
        case types.DELETED_PHASENOTE_INCOMING:
        case types.UPDATED_PROJECTITEMACTIVITY_INCOMING:
        case types.DELETED_PROJECTITEMACTIVITY_INCOMING:
        case types.UPDATED_PROJECTITEMMILESTONE_INCOMING:
        case types.DELETED_PROJECTITEMMILESTONE_INCOMING:
        case types.UPDATED_PROJECTITEM_INCOMING:
        case types.UPDATED_PHASE_INCOMING:
        case types.DELETED_PHASE_INCOMING:
        case types.DELETED_INVOICE_INCOMING:
            return mergeIdIn(state, action.payload.projectId);
        case types.CREATED_INVOICE_INCOMING:
            return mergeIdIn(state, action.payload.id);
        default:
            return state;
    }
}